import { cloneDeep, unset } from 'lodash'
import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

export const UserProfileState = {
  loadingUserProfile: false,
  userProfile: {},
}

export const UserProfileActions = {

  loadUserProfile: async ({ commit }, userId) => {
    commit('setLoadingUserProfile', true)

    return axiosRequest.
      get(`/users/${userId}`).
      then(({ data }) => {
        commit('setUserProfile', data.user)
        commit('setUserModel', data.user, { root: true })
      }).
      catch(handleError).
      finally(_ => commit('setLoadingUserProfile', false))
  },

  loadPublicUserProfile: async ({ commit }, userId) => {
    commit('setLoadingUserProfile', true)

    return axiosRequest.
      get(`/users/${userId}/public_profile`).
      then(({ data }) => {
        commit('setUserProfile', data.user)
        commit('setUserModel', data.user, { root: true })
      }).
      catch(handleError).
      finally(_ => commit('setLoadingUserProfile', false))
  },

  updateUserProfile: async ({ commit, rootState }, { userId, profile }) => {
    const params = { user: cloneDeep(profile) }

    if (params.user.addresses) {
      params.user.addresses_attributes = params.user.addresses
      unset(params.user, 'addresses')
    }

    if (params.user.bar_memberships) {
      params.user.bar_memberships_attributes = params.user.bar_memberships
      unset(params.user, 'bar_memberships')
    }

    if (params.user.email_addresses) {
      params.user.email_addresses_attributes = params.user.email_addresses
      unset(params.user, 'email_addresses')
    }

    if (params.user.phone_numbers) {
      params.user.phone_numbers_attributes = params.user.phone_numbers
      unset(params.user, 'phone_numbers')
    }

    return axiosRequest.
      patch(`/users/${userId}`, params).
      then(({ data }) => {
        commit('setUserProfile', data.user)
        commit('setUserModel', data.user, { root: true })

        if (rootState.currentUser?.id === data.user.id) {
          commit('setCurrentUser', data.user, { root: true })
        }
      }).
      catch(handleError)
  },

}

export const UserProfileMutations = {
  setLoadingUserProfile: (state, loading) => { state.loadingUserProfile = loading },
  setUserProfile: (state, profile) => { state.userProfile = profile },
}

export const UserProfileGetters = {
  loadingUserProfile: state => state.loadingUserProfile,
  userProfile: state => state.userProfile,
}
